import { TmrBaseResource } from 'stylewhere/api'

export class EnumerationValues extends TmrBaseResource {
  static endpoint = 'profile/api/v1/enumerationvalues'
}
